import {
  AXIS_FONT_SIZE,
  EXPANDED_AXIS_FONT_SIZE,
  EXPANDED_CHART_CLASS
} from './channel-drawer-constants';

// The drawer's copy of a chart stays mounted under the expand-chart modal and comes first in the
// DOM, so a PNG taken from the enlarged view has to scope its selector to the modal to capture the
// copy the user is looking at.
export const pngSelectorFor = (chartSelector: string, isExpanded: boolean): string =>
  isExpanded ? `.${EXPANDED_CHART_CLASS} ${chartSelector}` : chartSelector;

export const axisFontSizeFor = (isExpanded: boolean): number =>
  isExpanded ? EXPANDED_AXIS_FONT_SIZE : AXIS_FONT_SIZE;
